import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { User } from '../interfaces/user'
import formatBelgianPhoneNumber from '../fonctions/formatBelgiumPhone'
import { Work } from '../interfaces/work'
import GalleryCards from './GalleryCards'
import { API_BASE_URL, X_API_KEY } from '../../services/api'

interface WorkCardProps {
  work: Work
  user: User
  gallery: {
    id: number
    fileUrl: string
    fileName: string
    cover?: boolean
    status: number
  }[]
  statusToShow: number[]
}

export const WorkCard: React.FC<WorkCardProps> = ({
  work,
  user,
  gallery,
  statusToShow,
}) => {
  console.log('📌 WorkCard rendu avec :', work, user, gallery, statusToShow)
  const navigate = useNavigate()
  const location = useLocation()
  console.log('🖼️ Galerie reçue dans WorkCard :', gallery)
  console.log(
    '🎯 Images filtrées avec statusToShow :',
    gallery.filter(img => statusToShow.includes(img.status)),
  )

  const formatURL = (title: string, id: number) => {
    return `${title
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')}/${id}`
  }

  const handleClick = async (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    event.preventDefault()
    console.log('🚀 Click détecté sur WorkCard pour :', work.title)

    try {
      const response = await fetch(`${API_BASE_URL}/work/${work.id}/view`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'x-api-key': X_API_KEY || '',
        },
      })

      if (!response.ok) throw new Error('❌ Erreur réseau')
      const data = await response.json()
      console.log('✅ Données reçues après fetch :', data)

      navigate(`/work/${formatURL(work.title, work.id)}`, {
        state: { from: location.pathname, workData: data },
      })
    } catch (error) {
      console.error('❌ Erreur lors du fetch :', error)
    }
  }

  const userGender = user?.userProfile?.gender || 'unknown'
  const userZipCode = user?.address?.zip_code || ''
  const userCity = user?.address?.city || ''
  const userStreetNumber = user?.address?.number || ''
  const userStreet = user?.address?.street || ''

  return (
    <Link
      to={`/work/${formatURL(work.title, work.id)}`}
      className='group bg-grisclair text-redpink hover:bg-redpink transition-all rounded-lg shadow-md'
      style={{
        fontFamily: 'Poppins, sans-serif',
      }}
      onClick={handleClick}
    >
      <div className='overflow-hidden rounded-t-lg h-44'>
        <GalleryCards
          gallery={gallery}
          coverImage={gallery.find(img => img.cover)}
          gender={userGender}
          statusToShow={statusToShow}
          customDefaultImage='/images/silouhette-work.jpg'
        />
      </div>

      <div className='text-center p-3'>
        <p className='text-redpink uppercase font-bold group-hover:text-white transition-all'>
          {work.title}
        </p>
        <p className='text-anthracite group-hover:text-white group-hover:opacity-80 transition-all'>
          {userZipCode} {userCity}
        </p>
        <p className='text-anthracite group-hover:text-white group-hover:opacity-80 transition-all'>
          {userStreetNumber} {userStreet}
        </p>

        <p className='text-anthracite group-hover:text-white group-hover:opacity-80 transition-all'>
          {user.phone ? formatBelgianPhoneNumber(user.phone) : 'N/A'}
        </p>
      </div>
    </Link>
  )
}

export default WorkCard
